// filepath: /Users/carlosmartinez/Desktop/url_shortener/front/src/EditURL.js
import React from 'react';

function EditURL() {
  return (
    <div>
      <h1>Edit URL</h1>
      {/* Aquí puedes añadir el código para editar una URL */}
    </div>
  );
}

export default EditURL;